import slick from '@accessible360/accessible-slick';
import $ from 'jQuery';

export default function () {
	$(function() {
		carousel_cta();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class Slider {
    /**
     * Slider Constructor
     * @param {HTML Element} element Element to transform into a slick slider.
     * @param {object} options Optional settings to overwrite the defaults.
     */
     constructor(element, options) {
      // Grabs reference to the passed in element.
      this.element = element;

      // We can pass in alternate options to overwrite the defaults.
      this.settings = { ...slickDefaults, ...options };

      // Sets a slider variable from the returned slick slider instance built.
      this.slider = this.build();

      // Calls a utility ready function when everything is done.
      this.ready();
    }

    /**
     * Builds out a slick slider from the element and the settings.
     * @returns jQuery Element
     */
    build() {
    	return $(this.element).slick(this.settings);
    }

    /**
     * Utility function to add a ready class to the element.
     */
    ready() {
     	this.element.classList.add('ready');
    }
  }

  function carousel_cta() {
    const $carousel = $('.block--carousel-cta');

    if ($carousel.length) {
      $('.carousel-cta--slider', $carousel).each(function() {
        const $thisSlider = $(this);
        const $sliderContainer = $thisSlider.parent();
        const $prevButton = $sliderContainer.find('.carousel-cta--previous-button');
        const $nextButton = $sliderContainer.find('.carousel-cta--next-button');
        let el = $thisSlider[0];

        const slickSettings = {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          prevArrow: $prevButton,
          nextArrow: $nextButton,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 650,
              settings: {
                slidesToShow: 1,
                dots: true,
              }
            },
          ]
        };

        if (!el.Slider) {
          el.Slider = new Slider(el, slickSettings);
        }
      });
    }
  }
}
